// @ts-nocheck

import dayjs from 'dayjs'
import PropTypes from 'prop-types'
import React from 'react'

export default function DateTimeCell(props) {
  const { style, value } = props

  return <div style={style}>{dayjs(value).format('DD-MM-YYYY HH:mm')}</div>
}

DateTimeCell.propTypes = {
  style: PropTypes.object,
  value: PropTypes.string.isRequired
}
